<template>
  <div class="connect-button">
    <button 
      @click="connect" 
      :disabled="connecting"
      class="btn-connect"
    >
      {{ connecting ? 'Connecting...' : 'Connect ServiceM8' }}
    </button>
    <p class="help-text">Click to authorize ServiceM8 integration</p>
  </div>
</template>

<script>
export default {
  name: 'ConnectButton',
  data() {
    return {
      connecting: false,
    }
  },
  methods: {
    async connect() {
      this.connecting = true;
      try {
        const ssoToken = await this.getSSOToken();
        const response = await fetch('/servicem8/auth', {
          method: 'GET',
          headers: {
            'x-sso-token': ssoToken,
          },
        });
        
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
          throw new Error(errorData.message || errorData.error || `HTTP ${response.status}`);
        }
        
        const data = await response.json();
        
        if (data.authUrl) {
          // Open OAuth in a popup window
          console.log('Opening ServiceM8 OAuth in popup:', data.authUrl);
          this.openOAuthPopup(data.authUrl);
        } else {
          throw new Error('No authorization URL received from server');
        }
      } catch (error) {
        console.error('Error connecting ServiceM8:', error);
        const errorMessage = error instanceof Error ? error.message : 'Failed to initiate ServiceM8 connection';
        alert(`Failed to initiate ServiceM8 connection: ${errorMessage}`);
        this.connecting = false;
      }
    },
    openOAuthPopup(authUrl) {
      // Calculate popup dimensions (centered on screen)
      const width = 600;
      const height = 700;
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;
      
      // Open popup window
      const popup = window.open(
        authUrl,
        'ServiceM8 OAuth',
        `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
      );
      
      if (!popup) {
        alert('Popup blocked. Please allow popups for this site and try again.');
        this.connecting = false;
        return;
      }
      
      // Listen for messages from the popup
      const messageListener = (event) => {
        // Verify origin for security (adjust to match your domain)
        if (event.origin !== window.location.origin) {
          return;
        }
        
        if (event.data.type === 'SERVICEM8_OAUTH_SUCCESS') {
          console.log('ServiceM8 OAuth successful');
          window.removeEventListener('message', messageListener);
          popup.close();
          this.connecting = false;
          
          // Emit event to parent component to refresh connection status
          this.$emit('connected');
        } else if (event.data.type === 'SERVICEM8_OAUTH_ERROR') {
          console.error('ServiceM8 OAuth error:', event.data.error);
          window.removeEventListener('message', messageListener);
          popup.close();
          this.connecting = false;
          alert(`ServiceM8 connection failed: ${event.data.error}`);
        }
      };
      
      window.addEventListener('message', messageListener);
      
      // Check if popup is closed manually
      const checkClosed = setInterval(() => {
        if (popup.closed) {
          clearInterval(checkClosed);
          window.removeEventListener('message', messageListener);
          this.connecting = false;
        }
      }, 500);
    },
    async getSSOToken() {
      return await new Promise((resolve) => {
        window.parent.postMessage({ message: "REQUEST_USER_DATA" }, "*");
        window.addEventListener("message", ({ data }) => {
          if (data.message === "REQUEST_USER_DATA_RESPONSE") {
            resolve(data.payload);
          }
        });
      });
    }
  }
}
</script>

<style scoped>
.connect-button {
  text-align: center;
  padding: 20px;
}

.btn-connect {
  padding: 12px 24px;
  background: linear-gradient(135deg, #009dff 0%, #00b8ff 50%, #00e3ff 100%) !important;
  background-image: linear-gradient(135deg, #009dff 0%, #00b8ff 50%, #00e3ff 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s ease, background-image 0.3s ease;
  box-shadow: 0 2px 8px rgba(36, 172, 254, 0.3);
}

.btn-connect:hover:not(:disabled) {
  background: linear-gradient(315deg, #00e3ff 0%, #00b8ff 50%, #009dff 100%) !important;
  background-image: linear-gradient(315deg, #00e3ff 0%, #00b8ff 50%, #009dff 100%) !important;
}

.btn-connect:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.help-text {
  margin-top: 10px;
  color: #666;
  font-size: 14px;
}
</style>

